import React from "react";
import {
  Card,
  Col,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
} from "reactstrap";

const MobileSavedUser = ({
  showUserSheet,
  toggleUserSheet,
  savedUsers,
  handleCardClick,
  handleDeleteUser
}) => {
  return (
    <Offcanvas
      isOpen={showUserSheet}
      toggle={toggleUserSheet}
      direction="bottom"
      // className="bottom-sheet-offcanvas"
      style={{
        // height: "60vh",
        height: "fit-content",
        // maxHeight: "100vh",
        transition: "transform 0.3s ease",
        borderTopLeftRadius: "1rem",
        borderTopRightRadius: "1rem",
        zIndex: 1050,
      }}
    >
      <OffcanvasHeader toggle={toggleUserSheet}>Select User</OffcanvasHeader>
      <OffcanvasBody>
        <Row className="">
          {savedUsers?.length > 0 ? (
            savedUsers.map((item, index) => (
              <Col key={index} xs={12}>
                <Card
                  onClick={() => {
                    handleCardClick(item?.user?.email);
                    toggleUserSheet();
                  }}
                  className=" text-center p-2 border-0 cursor-pointer bg-light"
                >
                  <Row className="">
                    {/* Avatar */}
                    <Col xs={3} className="d-flex justify-content-center">
                      <div
                        className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center"
                        style={{
                          width: "45px",
                          height: "45px",
                          fontSize: "1rem",
                          fontWeight: "700",
                        }}
                      >
                        {item?.user?.email?.substring(0, 2).toUpperCase()}
                      </div>
                    </Col>

                    {/* User Info */}
                    <Col xs={9} className="text-start">
                      <h6
                        className="mb-1 fw-bold text-truncate"
                        title={item?.user?.email} // tooltip for full email
                      >
                        {item?.user?.email}
                      </h6>
                      <div className="d-flex justify-content-between align-content-center align-items-center">
                        <span className="badge rounded-pill bg-light text-dark shadow-sm">
                          {item?.user?.roles[0]}
                        </span>
                        <button
                          className="btn btn-sm"
                          onClick={() => handleDeleteUser(item?.user?.email)}
                        >
                          <i className="ri-delete-bin-line text-danger"></i>
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Col>
            ))
          ) : (
            <div className="text-center text-muted py-3">
              No saved users found
            </div>
          )}
        </Row>
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default MobileSavedUser;
